import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Shell from "../components/Shell.jsx";
import TransactionForm from "../components/TransactionForm.jsx";
import { api } from "../lib/api.js";

export default function EditEntry() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [txn, setTxn] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api(`/api/transactions/${id}`)
      .then((d) => setTxn(d.transaction))
      .catch(() => setError("Entry not found."));
  }, [id]);

  async function remove() {
    if (!window.confirm("Delete this entry? It stays in the audit log.")) return;
    await api(`/api/transactions/${id}`, { method: "DELETE" });
    navigate("/ledger");
  }

  return (
    <Shell title="Edit entry" back>
      <div className="rounded-2xl bg-white p-5 shadow-sm">
        {error && <p className="text-sm text-red-600">{error}</p>}
        {!txn && !error && <p className="text-sm text-slate-400">Loading…</p>}
        {txn && <TransactionForm initial={txn} submitLabel="Save changes" onSaved={() => navigate("/ledger")} />}
      </div>
      {txn && (
        <button onClick={remove} className="w-full rounded-xl border border-red-200 py-3 text-sm font-semibold text-red-600">
          Delete entry
        </button>
      )}
    </Shell>
  );
}
